// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { EntityAttachmentsSection } from '@/components/entity-attachments-section';
import { addPurchaseOrderURLLink } from '@/purchase-order/api/add-purchase-order-url-link';
import { deletePurchaseOrderFile } from '@/purchase-order/api/delete-purchase-order-file';
import { uploadPurchaseOrderFile } from '@/purchase-order/api/upload-purchase-order-file';
import { usePurchaseOrderFiles } from '@/purchase-order/hooks/use-purchase-order-files';
import { usePurchaseOrderURLLinks } from '@/purchase-order/hooks/use-purchase-order-url-links';
import {
  purchaseOrderDetailQueryKey,
  purchaseOrderFilesQueryKey,
  purchaseOrderURLLinksQueryKey,
} from '@/purchase-order/query-keys';

interface Props {
  /** The key of the purchase order */
  purchaseOrderKey: string;
  /** The ID of the purchase order (used for uploads) */
  purchaseOrderId: string;
}

/**
 * Section component for displaying and managing files and URL links on the
 * purchase order detail page. Rendered inline in the right column.
 */
export function PurchaseOrderAttachmentsSection(props: Props) {
  const filesData = usePurchaseOrderFiles({
    purchaseOrderKey: props.purchaseOrderKey,
  });
  const urlLinksData = usePurchaseOrderURLLinks({
    purchaseOrderKey: props.purchaseOrderKey,
  });

  return (
    <EntityAttachmentsSection
      entityKey={props.purchaseOrderKey}
      entityId={props.purchaseOrderId}
      ownerType="purchaseOrder"
      filesData={filesData}
      urlLinksData={urlLinksData}
      uploadFile={uploadPurchaseOrderFile}
      addURLLink={addPurchaseOrderURLLink}
      deleteFile={deletePurchaseOrderFile}
      queryKeysToInvalidate={[
        purchaseOrderDetailQueryKey(props.purchaseOrderKey),
        purchaseOrderFilesQueryKey(props.purchaseOrderKey),
        purchaseOrderURLLinksQueryKey(props.purchaseOrderKey),
      ]}
    />
  );
}
